import { html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { LeafElement } from "../leaf-element.js";
import { a as getAugmentedNamespace, c as commonjsGlobal, g as getDefaultExportFromCjs } from "../../_commonjsHelpers-LQfde5yM.js";
import { appendStylesheet } from "../../utilities/light-dom-styles.js";
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var topLevel = typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof window !== "undefined" ? window : {};
var minDoc = require$$0;
var doccy;
if (typeof document !== "undefined") {
  doccy = document;
} else {
  doccy = topLevel["__GLOBAL_DOCUMENT_CACHE@4"];
  if (!doccy) {
    doccy = topLevel["__GLOBAL_DOCUMENT_CACHE@4"] = minDoc;
  }
}
var document_1 = doccy;
const document$1 = /* @__PURE__ */ getDefaultExportFromCjs(document_1);
var win;
if (typeof window !== "undefined") {
  win = window;
} else if (typeof commonjsGlobal !== "undefined") {
  win = commonjsGlobal;
} else if (typeof self !== "undefined") {
  win = self;
} else {
  win = {};
}
var window_1 = win;
const window$1 = /* @__PURE__ */ getDefaultExportFromCjs(window_1);
/*! @name @brightcove/player-loader @version 1.8.0 @license Apache-2.0 */
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key3 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key3)) {
          target[key3] = source[key3];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var version = "1.8.0";
/*! @name @brightcove/player-url @version 1.2.0 @license Apache-2.0 */
var version$1 = "1.2.0";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var JSON_ALLOWED_PARAMS = ["catalogSearch", "catalogSequence"];
var IFRAME_ALLOWED_QUERY_PARAMS = ["adConfigId", "applicationId", "catalogSearch", "catalogSequence", "playlistId", "playlistVideoId", "videoId"];
var getQueryParamValue = function getQueryParamValue2(params, key3) {
  if (!params || params[key3] === void 0) {
    return;
  }
  if (typeof params[key3] !== "string" && JSON_ALLOWED_PARAMS.indexOf(key3) !== -1) {
    try {
      return encodeURIComponent(JSON.stringify(params[key3]));
    } catch (x) {
      return;
    }
  }
  return encodeURIComponent(String(params[key3]).trim()) || void 0;
};
var getQueryString = function getQueryString2(params) {
  return Object.keys(params).filter(function(k) {
    return IFRAME_ALLOWED_QUERY_PARAMS.indexOf(k) !== -1;
  }).reduce(function(qs, k) {
    var value = getQueryParamValue(params, k);
    if (value !== void 0) {
      qs += qs ? "&" : "?";
      qs += encodeURIComponent(k) + "=" + value;
    }
    return qs;
  }, "");
};
var brightcovePlayerUrl = function brightcovePlayerUrl2(_ref) {
  var accountId = _ref.accountId, _ref$base = _ref.base, base = _ref$base === void 0 ? "https://players.brightcove.net" : _ref$base, _ref$playerId = _ref.playerId, playerId = _ref$playerId === void 0 ? "default" : _ref$playerId, _ref$embedId = _ref.embedId, embedId = _ref$embedId === void 0 ? "default" : _ref$embedId, _ref$iframe = _ref.iframe, iframe = _ref$iframe === void 0 ? false : _ref$iframe, _ref$minified = _ref.minified, minified = _ref$minified === void 0 ? true : _ref$minified, _ref$queryParams = _ref.queryParams, queryParams = _ref$queryParams === void 0 ? null : _ref$queryParams;
  var ext = "";
  if (iframe) {
    ext += "html";
  } else {
    if (minified) {
      ext += "min.";
    }
    ext += "js";
  }
  if (base.charAt(base.length - 1) === "/") {
    base = base.substring(0, base.length - 1);
  }
  var qs = "";
  if (iframe && queryParams && (typeof queryParams === "undefined" ? "undefined" : _typeof(queryParams)) === "object") {
    qs = getQueryString(queryParams);
  }
  accountId = encodeURIComponent(accountId);
  playerId = encodeURIComponent(playerId);
  embedId = encodeURIComponent(embedId);
  return base + "/" + accountId + "/" + playerId + "_" + embedId + "/index." + ext + qs;
};
brightcovePlayerUrl.VERSION = version$1;
var DEFAULTS = {
  embedId: "default",
  embedType: "in-page",
  playerId: "default",
  Promise: window$1.Promise,
  refNodeInsert: "append"
};
var DEFAULT_ASPECT_RATIO = "16:9";
var DEFAULT_IFRAME_HORIZONTAL_PLAYLIST = false;
var DEFAULT_MAX_WIDTH = "100%";
var EMBED_TAG_NAME_VIDEO = "video";
var EMBED_TAG_NAME_VIDEOJS = "video-js";
var EMBED_TYPE_IN_PAGE = "in-page";
var EMBED_TYPE_IFRAME = "iframe";
var REF_NODE_INSERT_APPEND = "append";
var REF_NODE_INSERT_PREPEND = "prepend";
var REF_NODE_INSERT_BEFORE = "before";
var REF_NODE_INSERT_AFTER = "after";
var REF_NODE_INSERT_REPLACE = "replace";
var JSON_ALLOWED_ATTRS = ["catalogSearch", "catalogSequence"];
var BASE_URL = "https://players.brightcove.net/";
var getUrl = function getUrl2(params) {
  if (params.playerUrl) {
    return params.playerUrl;
  }
  var accountId = params.accountId, playerId = params.playerId, embedId = params.embedId, embedOptions = params.embedOptions;
  var iframe = params.embedType === EMBED_TYPE_IFRAME;
  return brightcovePlayerUrl({
    accountId,
    playerId,
    embedId,
    iframe,
    base: BASE_URL,
    // The unminified embed option is the exact reverse of the minified option
    // here.
    minified: embedOptions ? !embedOptions.unminified : true,
    // Pass the entire params object as query params. This is safe because
    // @brightcove/player-url only accepts a whitelist of parameters. Anything
    // else will be ignored.
    queryParams: params
  });
};
var getBaseUrl = function getBaseUrl2() {
  return BASE_URL;
};
var setBaseUrl = function setBaseUrl2(baseUrl) {
  BASE_URL = baseUrl;
};
var urls = {
  getUrl,
  getBaseUrl,
  setBaseUrl
};
var isEl = function isEl2(el) {
  return Boolean(el && el.nodeType === 1);
};
var isElInDom = function isElInDom2(el) {
  return Boolean(isEl(el) && el.parentNode);
};
var createIframeEmbed = function createIframeEmbed2(params) {
  var el = document$1.createElement("iframe");
  el.setAttribute("allow", "autoplay;encrypted-media;fullscreen");
  el.setAttribute("allowfullscreen", "allowfullscreen");
  el.src = urls.getUrl(params);
  return el;
};
var createInPageEmbed = function createInPageEmbed2(params) {
  var embedOptions = params.embedOptions;
  var paramsToAttrs = {
    adConfigId: "data-ad-config-id",
    applicationId: "data-application-id",
    catalogSearch: "data-catalog-search",
    catalogSequence: "data-catalog-sequence",
    deliveryConfigId: "data-delivery-config-id",
    playlistId: "data-playlist-id",
    playlistVideoId: "data-playlist-video-id",
    poster: "poster",
    videoId: "data-video-id"
  };
  var tagName = embedOptions && embedOptions.tagName || EMBED_TAG_NAME_VIDEOJS;
  var el = document$1.createElement(tagName);
  Object.keys(paramsToAttrs).filter(function(key3) {
    return params[key3];
  }).forEach(function(key3) {
    var value;
    if (typeof params[key3] !== "string" && JSON_ALLOWED_ATTRS.indexOf(key3) !== -1) {
      try {
        value = JSON.stringify(params[key3]);
      } catch (x) {
        return;
      }
    } else {
      value = String(params[key3]).trim();
    }
    el.setAttribute(paramsToAttrs[key3], value);
  });
  el.setAttribute("controls", "controls");
  el.classList.add("video-js");
  return el;
};
var wrapResponsive = function wrapResponsive2(embedType, embedOptions, el) {
  if (!embedOptions.responsive) {
    return el;
  }
  el.style.position = "absolute";
  el.style.top = "0px";
  el.style.right = "0px";
  el.style.bottom = "0px";
  el.style.left = "0px";
  el.style.width = "100%";
  el.style.height = "100%";
  var responsive = _extends({
    aspectRatio: DEFAULT_ASPECT_RATIO,
    iframeHorizontalPlaylist: DEFAULT_IFRAME_HORIZONTAL_PLAYLIST,
    maxWidth: DEFAULT_MAX_WIDTH
  }, embedOptions.responsive);
  var aspectRatio = responsive.aspectRatio.split(":").map(Number);
  var inner = document$1.createElement("div");
  var paddingTop = aspectRatio[1] / aspectRatio[0] * 100;
  if (embedType === EMBED_TYPE_IFRAME && responsive.iframeHorizontalPlaylist) {
    paddingTop *= 1.25;
  }
  inner.style.paddingTop = paddingTop + "%";
  inner.appendChild(el);
  var outer = document$1.createElement("div");
  outer.style.position = "relative";
  outer.style.display = "block";
  outer.style.maxWidth = responsive.maxWidth;
  outer.appendChild(inner);
  return outer;
};
var wrapPip = function wrapPip2(embedOptions, el) {
  if (!embedOptions.pip) {
    return el;
  }
  var pip = document$1.createElement("div");
  pip.classList.add("vjs-pip-container");
  pip.appendChild(el);
  return pip;
};
var wrapEmbed = function wrapEmbed2(embedType, embedOptions, embed) {
  if (!embedOptions) {
    return embed;
  }
  return wrapPip(embedOptions, wrapResponsive(embedType, embedOptions, embed));
};
var insertEmbed = function insertEmbed2(params, embed) {
  var refNode = params.refNode, refNodeInsert = params.refNodeInsert;
  var refNodeParent = refNode.parentNode;
  var wrapped = wrapEmbed(params.embedType, params.embedOptions, embed);
  if (refNodeInsert === REF_NODE_INSERT_BEFORE) {
    refNodeParent.insertBefore(wrapped, refNode);
  } else if (refNodeInsert === REF_NODE_INSERT_AFTER) {
    refNodeParent.insertBefore(wrapped, refNode.nextElementSibling || null);
  } else if (refNodeInsert === REF_NODE_INSERT_REPLACE) {
    refNodeParent.replaceChild(wrapped, refNode);
  } else if (refNodeInsert === REF_NODE_INSERT_PREPEND) {
    refNode.insertBefore(wrapped, refNode.firstChild || null);
  } else {
    refNode.appendChild(wrapped);
  }
  if (params.embedOptions && params.embedOptions.playlist) {
    var playlistTagName = params.embedOptions.playlist.legacy ? "ul" : "div";
    var playlist = document$1.createElement(playlistTagName);
    playlist.classList.add("vjs-playlist");
    embed.parentNode.insertBefore(playlist, embed.nextElementSibling || null);
  }
  params.refNode = null;
  return embed;
};
var onEmbedCreated = function onEmbedCreated2(params, embed) {
  if (typeof params.onEmbedCreated !== "function") {
    return embed;
  }
  var result = params.onEmbedCreated(embed);
  if (isEl(result)) {
    return result;
  }
  return embed;
};
var createEmbed = function createEmbed2(params) {
  var embed = params.embedType === EMBED_TYPE_IFRAME ? createIframeEmbed(params) : createInPageEmbed(params);
  return insertEmbed(params, onEmbedCreated(params, embed));
};
var actualCache = new window$1.Map();
var key = function key2(_ref) {
  var accountId = _ref.accountId, playerId = _ref.playerId, embedId = _ref.embedId;
  return (accountId || "*") + "_" + playerId + "_" + embedId;
};
var store = function store2(props) {
  actualCache.set(key(props), props.accountId ? urls.getUrl(props) : "");
};
var has = function has2(props) {
  return actualCache.has(key(props));
};
var get = function get2(props) {
  return actualCache.get(key(props));
};
var clear = function clear2() {
  actualCache.clear();
};
var forEach = function forEach2(fn) {
  actualCache.forEach(fn);
};
var playerScriptCache = {
  clear,
  forEach,
  get,
  has,
  key,
  store
};
var REGEX_PLAYER_EMBED = /^([A-Za-z0-9]+)_([A-Za-z0-9]+)$/;
var getBcGlobalKeys = function getBcGlobalKeys2() {
  return window$1.bc ? Object.keys(window$1.bc).filter(function(k) {
    return REGEX_PLAYER_EMBED.test(k);
  }) : [];
};
var getGlobalKeys = function getGlobalKeys2() {
  return Object.keys(window$1).filter(function(k) {
    return /^videojs/i.test(k) || /^(bc)$/.test(k);
  });
};
var disposeAll = function disposeAll2(videojs) {
  if (!videojs) {
    return;
  }
  Object.keys(videojs.players).forEach(function(k) {
    var p = videojs.players[k];
    if (p) {
      p.dispose();
    }
  });
};
var reset = function reset2() {
  playerScriptCache.forEach(function(value, key3) {
    if (!value) {
      return;
    }
    Array.prototype.slice.call(document$1.querySelectorAll('script[src="' + value + '"]')).forEach(function(el) {
      return el.parentNode.removeChild(el);
    });
  });
  playerScriptCache.clear();
  disposeAll(window$1.videojs);
  getBcGlobalKeys().forEach(function(k) {
    return disposeAll(window$1.bc[k].videojs);
  });
  getGlobalKeys().forEach(function(k) {
    delete window$1[k];
  });
};
var detectPlayers = function detectPlayers2() {
  getBcGlobalKeys().forEach(function(k) {
    var matches = k.match(REGEX_PLAYER_EMBED);
    var props = {
      playerId: matches[1],
      embedId: matches[2]
    };
    if (!playerScriptCache.has(props)) {
      playerScriptCache.store(props);
    }
  });
};
var env = {
  detectPlayers,
  reset
};
env.detectPlayers();
var isFn = function isFn2(fn) {
  return typeof fn === "function";
};
var isValidEmbedType = function isValidEmbedType2(embedType) {
  return embedType === EMBED_TYPE_IN_PAGE || embedType === EMBED_TYPE_IFRAME;
};
var isValidTagName = function isValidTagName2(tagName) {
  return tagName === EMBED_TAG_NAME_VIDEOJS || tagName === EMBED_TAG_NAME_VIDEO;
};
var isValidRootInsert = function isValidRootInsert2(refNodeInsert) {
  return refNodeInsert === REF_NODE_INSERT_APPEND || refNodeInsert === REF_NODE_INSERT_PREPEND || refNodeInsert === REF_NODE_INSERT_BEFORE || refNodeInsert === REF_NODE_INSERT_AFTER || refNodeInsert === REF_NODE_INSERT_REPLACE;
};
var checkParams = function checkParams2(params) {
  var accountId = params.accountId, embedOptions = params.embedOptions, embedType = params.embedType, options = params.options, refNode = params.refNode, refNodeInsert = params.refNodeInsert;
  if (!accountId) {
    throw new Error("accountId is required");
  } else if (!isElInDom(refNode)) {
    throw new Error("refNode must resolve to a node attached to the DOM");
  } else if (!isValidEmbedType(embedType)) {
    throw new Error("embedType is missing or invalid");
  } else if (embedType === EMBED_TYPE_IFRAME && options) {
    throw new Error("cannot use options with an iframe embed");
  } else if (embedOptions && embedOptions.tagName !== void 0 && !isValidTagName(embedOptions.tagName)) {
    throw new Error('embedOptions.tagName is invalid (value: "' + embedOptions.tagName + '")');
  } else if (embedOptions && embedOptions.responsive && embedOptions.responsive.aspectRatio && !/^\d+\:\d+$/.test(embedOptions.responsive.aspectRatio)) {
    throw new Error('embedOptions.responsive.aspectRatio must be in the "n:n" format (value: "' + embedOptions.responsive.aspectRatio + '")');
  } else if (!isValidRootInsert(refNodeInsert)) {
    throw new Error("refNodeInsert is missing or invalid");
  }
};
var resolveRefNode = function resolveRefNode2(refNode) {
  if (isElInDom(refNode)) {
    return refNode;
  }
  if (typeof refNode === "string") {
    return document$1.querySelector(refNode);
  }
  return null;
};
var initPlayer = function initPlayer2(params, embed, resolve, reject) {
  var embedId = params.embedId, playerId = params.playerId;
  var bc = window$1.bc[playerId + "_" + embedId] || window$1.bc;
  if (!bc) {
    return reject(new Error("missing bc function for " + playerId));
  }
  playerScriptCache.store(params);
  var player;
  try {
    player = bc(embed, params.options);
    if (player.bcinfo) {
      player.bcinfo.PLAYER_LOADER = true;
    }
  } catch (x) {
    var message = "Could not initialize the Brightcove Player.";
    if (params.embedOptions.tagName === EMBED_TAG_NAME_VIDEOJS) {
      message += ' You are attempting to embed using a "video-js" element. Please ensure that your Player is v6.11.0 or newer in order to support this embed type. Alternatively, pass `"video"` for `embedOptions.tagName`.';
    }
    return reject(new Error(message));
  }
  resolve({
    type: EMBED_TYPE_IN_PAGE,
    ref: player
  });
};
var loadPlayer = function loadPlayer2(params, resolve, reject) {
  params.refNode = resolveRefNode(params.refNode);
  checkParams(params);
  var refNode = params.refNode, refNodeInsert = params.refNodeInsert;
  var refNodeParent = refNode.parentNode;
  var embed = createEmbed(params);
  if (params.embedType === EMBED_TYPE_IFRAME) {
    resolve({
      type: EMBED_TYPE_IFRAME,
      ref: embed
    });
    return;
  }
  if (playerScriptCache.has(params)) {
    return initPlayer(params, embed, resolve, reject);
  }
  var script = document$1.createElement("script");
  script.onload = function() {
    return initPlayer(params, embed, resolve, reject);
  };
  script.onerror = function() {
    reject(new Error("player script could not be downloaded"));
  };
  script.async = true;
  script.charset = "utf-8";
  script.src = urls.getUrl(params);
  if (refNodeInsert === REF_NODE_INSERT_REPLACE) {
    refNodeParent.appendChild(script);
  } else {
    refNode.appendChild(script);
  }
};
var brightcovePlayerLoader = function brightcovePlayerLoader2(parameters) {
  var params = _extends({}, DEFAULTS, parameters);
  var Promise2 = params.Promise, onSuccess = params.onSuccess, onFailure = params.onFailure;
  if (!isFn(Promise2) || isFn(onSuccess) || isFn(onFailure)) {
    return loadPlayer(params, isFn(onSuccess) ? onSuccess : function() {
    }, isFn(onFailure) ? onFailure : function(err) {
      throw err;
    });
  }
  return new Promise2(function(resolve, reject) {
    return loadPlayer(params, resolve, reject);
  });
};
var expose = function expose2(key3, value) {
  Object.defineProperty(brightcovePlayerLoader, key3, {
    configurable: false,
    enumerable: true,
    value,
    writable: false
  });
};
expose("getBaseUrl", function() {
  return urls.getBaseUrl();
});
expose("setBaseUrl", function(baseUrl) {
  urls.setBaseUrl(baseUrl);
});
expose("getUrl", function(options) {
  return urls.getUrl(options);
});
expose("reset", function() {
  return env.reset();
});
[["EMBED_TAG_NAME_VIDEO", EMBED_TAG_NAME_VIDEO], ["EMBED_TAG_NAME_VIDEOJS", EMBED_TAG_NAME_VIDEOJS], ["EMBED_TYPE_IN_PAGE", EMBED_TYPE_IN_PAGE], ["EMBED_TYPE_IFRAME", EMBED_TYPE_IFRAME], ["REF_NODE_INSERT_APPEND", REF_NODE_INSERT_APPEND], ["REF_NODE_INSERT_PREPEND", REF_NODE_INSERT_PREPEND], ["REF_NODE_INSERT_BEFORE", REF_NODE_INSERT_BEFORE], ["REF_NODE_INSERT_AFTER", REF_NODE_INSERT_AFTER], ["REF_NODE_INSERT_REPLACE", REF_NODE_INSERT_REPLACE], ["VERSION", version]].forEach(function(arr) {
  expose(arr[0], arr[1]);
});
const styles = "/* ------------------------------------ *\\\n#MULTIMEDIA\n\\* ------------------------------------ */\n/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  --multimedia-limelight-active-bg: var(--leaf-base-color-opacity-neutral-25);\n}\n\n.vjs-control-bar {\n  background-color: var(--leaf-color-bg-brand-strong) !important;\n}\n\nleaf-multimedia-brightcove :not(:defined),\nleaf-multimedia-brightcove :not(:defined) * {\n  visibility: visible;\n}\n\n.leaf-c-multimedia-brightcove--video {\n  max-width: 1024px;\n}\n.leaf-c-multimedia-brightcove--video .vjs-title-bar {\n  display: none !important;\n}\n.leaf-c-multimedia-brightcove--video .video-js {\n  opacity: 1 !important;\n  visibility: visible !important;\n}\n.leaf-c-multimedia-brightcove--video .vjs-big-play-button {\n  background-color: rgba(0, 0, 0, 0) !important;\n  border: transparent !important;\n  left: 50% !important;\n  opacity: 0.5 !important;\n  top: 50% !important;\n}\n.leaf-c-multimedia-brightcove--video .vjs-big-play-button .vjs-icon-placeholder {\n  opacity: unset;\n  text-shadow: none !important;\n  font-size: var(--leaf-font-size-10) !important;\n  border: var(--leaf-border-width-focus) solid var(--leaf-color-border-transparent);\n  border-radius: var(--leaf-border-radius-default);\n  overflow: hidden;\n}\n.leaf-c-multimedia-brightcove--video .vjs-big-play-button .vjs-icon-placeholder:before {\n  background-color: var(--leaf-color-bg-brand-strong);\n  border: 10px solid var(--leaf-color-border-knockout);\n  border-radius: var(--leaf-border-radius-round);\n  box-shadow: var(--leaf-shadow-default);\n  color: var(--leaf-color-content-knockout);\n  position: relative !important;\n}\n.leaf-c-multimedia-brightcove--video .vjs-big-play-button .vjs-icon-placeholder:hover, .leaf-c-multimedia-brightcove--video .vjs-big-play-button .vjs-icon-placeholder:active {\n  border-color: transparent !important;\n}\n.leaf-c-multimedia-brightcove--video .vjs-big-play-button .vjs-icon-placeholder:focus-visible {\n  border: var(--leaf-border-width-focus) solid var(--leaf-color-border-brand);\n  outline: var(--leaf-border-width-focus) solid var(--leaf-color-border-active-outline);\n  outline-offset: var(--leaf-border-width-focus);\n  overflow: hidden;\n}\n\n.leaf-c-multimedia-brightcove--audio .video-js {\n  opacity: 1;\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key3, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key3) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key3, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key3, result);
  return result;
};
class LeafMultimediaBrightcove extends LeafElement {
  constructor() {
    super();
    this.account = "6415943385001";
    this.variant = "video";
    this._playerId = "";
    this._isLoaded = false;
    appendStylesheet("leaf-multimedia-styles", styles);
  }
  get playerId() {
    return this._playerId;
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this._playerId) {
      const num = Math.floor(Math.random() * 9e5) + 1e5;
      this._playerId = `brightcove_player_${num}`;
    }
  }
  async updated(changedProperties) {
    super.updated(changedProperties);
    const element = this.renderRoot.querySelector(`#${this.playerId}`);
    if (element) {
      element.innerHTML = "";
    }
    const observer = new IntersectionObserver(
      async (entries) => {
        if (entries[0].isIntersecting === true && !this._isLoaded) {
          this._isLoaded = true;
          await this.embedVideo();
        }
      },
      { threshold: [0] }
    );
    observer.observe(this.renderRoot);
  }
  /**
   * Embeds limelight_player to associated _playerId.
   */
  async embedVideo() {
    const objectImage = this;
    brightcovePlayerLoader({
      refNode: document.getElementById(this.playerId),
      accountId: this.account,
      playerId: "default",
      videoId: this.videoid,
      options: {
        fluid: "16:9"
      }
    }).then(function(success) {
      const myPlayer = success.ref;
      myPlayer.on("loadedmetadata", function() {
        if (objectImage.variant === "audio") {
          myPlayer.audioOnlyMode(true);
        }
      });
    }).catch(function(error) {
      console.error(error);
    });
  }
  render() {
    const componentClassName = {
      "leaf-c-multimedia-brightcove": true,
      "leaf-c-multimedia-brightcove--audio": this.variant === "audio",
      "leaf-c-multimedia-brightcove--video": this.variant === "video"
    };
    return html`<div class=${classMap(componentClassName)} id="${this.playerId}"></div>`;
  }
  /**
   *
   * lookup brightcove application-id
   */
  createRenderRoot() {
    return this;
  }
}
__decorateClass([
  property()
], LeafMultimediaBrightcove.prototype, "account", 2);
__decorateClass([
  property()
], LeafMultimediaBrightcove.prototype, "videoid", 2);
__decorateClass([
  property()
], LeafMultimediaBrightcove.prototype, "variant", 2);
export {
  LeafMultimediaBrightcove
};
//# sourceMappingURL=multimedia-brightcove.component.js.map
